import type { Repo } from "@/types";

export type SortKey = "stars" | "pushed_at" | "full_name";
export interface SortState {
  key: SortKey;
  dir: "asc" | "desc";
}

export const DEFAULT_SORT: SortState = { key: "stars", dir: "desc" };

function value(r: Repo, key: SortKey): number | string {
  if (key === "stars") return r.stars ?? -1;
  if (key === "pushed_at") return r.pushed_at ?? ""; // ISO strings sort chronologically
  return r.full_name.toLowerCase();
}

export function sortRepos(repos: Repo[], sort: SortState): Repo[] {
  const sorted = [...repos].sort((a, b) => {
    const av = value(a, sort.key);
    const bv = value(b, sort.key);
    const c = av < bv ? -1 : av > bv ? 1 : 0;
    return sort.dir === "asc" ? c : -c;
  });
  return sorted;
}

/** Toggle direction when re-clicking the active column, else switch with a sensible default. */
export function nextSort(current: SortState, key: SortKey): SortState {
  if (current.key === key) {
    return { key, dir: current.dir === "asc" ? "desc" : "asc" };
  }
  return { key, dir: key === "full_name" ? "asc" : "desc" };
}
